import { Link } from "react-router-dom";
import { ArrowRight, Moon } from "lucide-react";
import { Reveal, MaskLines } from "./motion/Reveal.jsx";
import { VARACHHA_PRESALE } from "../content.js";

const BG = "#0A1628";

export default function PreSaleBanner() {
  const p = VARACHHA_PRESALE;
  return (
    <section data-testid="home-presale-banner" className="relative overflow-hidden text-white" style={{ backgroundColor: BG }}>
      {/* Desktop mascot visual — inline, never cropped */}
      <div className="pointer-events-none absolute inset-y-0 right-0 hidden w-[62%] items-center lg:flex">
        <div className="relative w-full">
          <img
            src="/oneiros/mascots-trio-banner.jpg"
            alt=""
            className="aspect-[16/9] w-full object-cover"
          />
          <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0A1628] to-transparent" />
        </div>
      </div>

      <div className="relative z-10 mx-auto grid max-w-[1673px] lg:grid-cols-2">
        <div className="px-6 py-20 sm:px-10 lg:px-16 lg:py-24 xl:px-20">
          <Reveal>
            <p className="eyebrow flex items-center gap-3">
              <span className="relative flex h-3 w-3">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand opacity-75" />
                <span className="relative inline-flex h-3 w-3 rounded-full bg-brand" />
              </span>
              {p.eyebrow}
            </p>
          </Reveal>

          <h1 className="mt-6 font-display text-[clamp(2.5rem,4.7vw,4.4rem)] leading-[1.04]">
            <MaskLines as="span" lines={[p.titleTop]} className="block" />
            <MaskLines as="span" lines={[p.titleAccent]} className="block text-brand" delay={0.08} />
            <MaskLines as="span" lines={[p.titleBottom]} className="block whitespace-nowrap" delay={0.16} />
          </h1>

          <Reveal delay={0.25}>
            <p className="mt-7 max-w-xl text-base leading-relaxed text-white/75 md:text-lg">
              {p.copyLead}
              <span className="font-extrabold text-brand">{p.copyHighlight}</span>
              {p.copyTail}
            </p>
          </Reveal>

          <Reveal delay={0.32}>
            <div
              data-testid="home-presale-offer"
              className="mt-8 inline-flex flex-wrap items-center gap-x-4 gap-y-2 rounded-full border border-brand/50 bg-[#0d1b35]/70 px-6 py-3.5 backdrop-blur-sm"
            >
              <span className="flex items-center gap-2.5 text-xs font-extrabold uppercase tracking-[0.14em] text-white">
                <Moon className="h-4 w-4 text-brand" />
                {p.offerName}
              </span>
              <span className="hidden h-4 w-px bg-white/25 sm:block" />
              <span className="text-[11px] font-semibold uppercase tracking-[0.14em] text-white/70">
                First 500 Members: <span className="font-extrabold text-brand">No AMC</span>
              </span>
            </div>
          </Reveal>

          <Reveal delay={0.4}>
            <Link
              data-testid="home-presale-cta"
              to={p.to}
              className="group mt-7 inline-flex items-center gap-3 rounded-full bg-gradient-to-b from-[#FF9E45] to-[#E8681C] px-10 py-5 text-sm font-extrabold uppercase tracking-[0.12em] text-white shadow-[0_20px_45px_-14px_rgba(232,104,28,0.6)] transition-transform duration-300 hover:scale-[1.03]"
            >
              {p.cta}
              <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>

        {/* Mobile mascot visual */}
        <div className="relative w-full lg:hidden">
          <img
            src="/oneiros/mascots-trio-banner.jpg"
            alt="All three Oneiros mascots at Oneiros Varachha"
            data-testid="home-presale-mascot"
            className="aspect-[16/9] w-full object-cover"
          />
          <div className="pointer-events-none absolute inset-x-0 top-0 h-14 bg-gradient-to-b from-[#0A1628] to-transparent" />
        </div>
      </div>
    </section>
  );
}
